export default __webpack_public_path__ + "assets/images/aistudio/empty_state/82c5e80293dd177da2c6af37ed639409.png";